import './index.scss'
import Nova from '../../../assets/images/julio-lopez-nova.jpg'

const Portrait = () => {
    return (
        <div className="portrait-container">
            <img className="solid-image" src={Nova} alt="nova-lopez"/> 
        </div>
    )
} 

export default Portrait